import { Lock } from "lucide-react";
export function LockedBanner() {
  return (
    <div className="bg-yellow-50 border border-yellow-300 rounded-lg p-4 mb-4">
      <div className="flex items-center gap-2">
        <Lock className="h-5 w-5 text-yellow-700" />
        <div>
          <p className="text-sm font-medium text-yellow-800">
            {"Assessment Locked (Read-Only)"}
          </p>
          <p className="text-xs text-yellow-700 mt-0.5">
            {"This assessment has been finalized and cannot be modified. All fields are disabled."}
          </p>
        </div>
      </div>
    </div>
  );
}
